import { render, staticRenderFns } from "./ProfileSettingsNav.vue?vue&type=template&id=57227b20&scoped=true&"
import script from "./ProfileSettingsNav.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsNav.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingsNav.vue?vue&type=style&index=0&id=57227b20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57227b20",
  null
  
)

export default component.exports